import { assertNever } from '@/helpers/utils';
import { DrawableToolId } from '@/modules/toolbar/types';
import { Area } from '../types';
import { minItemsArrayUtils } from './minItems';

export const supportsLoadCarriers = (type: DrawableToolId): boolean => {
  switch (type) {
    case 'intake':
    case 'storage':
    case 'delivery':
    case 'process':
    case 'manual':
    case 'racking':
      return true;
    case 'charging':
    case 'highway':
    case 'highway_angled':
    case 'extraction':
    case 'insertion':
    case 'obstacle':
    case 'parking':
    case 'wall':
    case 'logical_space':
      return false;
    default: {
      assertNever(type);
    }
  }
};

export const getLoadCarrierByArea = (area: Area): string | undefined => {
  // TODO: support multi load carrier..., remove [0]
  const { areaType } = area;
  switch (areaType) {
    case 'MANUAL':
    case 'SINGULAR':
      return minItemsArrayUtils.mapAtLeast1(area.stationSpec.loadTypeIds, (id) => id)[0];
    case 'RACKING':
      return minItemsArrayUtils.mapAtLeast1(area.rackSpec.loadTypes, (id) => id.loadTypeId)[0];
    case 'STATIONARY':
    case 'HIGHWAY':
      // no load carriers...
      return;
    default:
      assertNever(areaType);
  }
};
